import { render, staticRenderFns } from "./VaBarChart.vue?vue&type=template&id=597095e2&scoped=true&"
import script from "./VaBarChart.vue?vue&type=script&lang=js&"
export * from "./VaBarChart.vue?vue&type=script&lang=js&"
import style0 from "./VaBarChart.vue?vue&type=style&index=0&id=597095e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597095e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('597095e2')) {
      api.createRecord('597095e2', component.options)
    } else {
      api.reload('597095e2', component.options)
    }
    module.hot.accept("./VaBarChart.vue?vue&type=template&id=597095e2&scoped=true&", function () {
      api.rerender('597095e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/charts/VaBarChart.vue"
export default component.exports